<template>
  <div id="app">
    <chessboard :fen="currentFen"/>
    <input id="inFEN" type="text" placeholder="FEN" style="width:300px;padding:5px 0 5px 2px">
    <button @click="loadFen()">Load</button>
  </div>
</template>

<script>
import chessboard from './components/chessboard.vue'
export default {
  name: 'App',
  components: {
    chessboard
  },
  data() {
    return {
      currentFen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    }
  },
  methods: {
    loadFen() {
      this.currentFen = document.getElementById("inFEN").value
    },
  },
}
</script>

<style lang="sass">
#app
  font-family: Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  color: #2c3e50
  margin-top: 30px

button
  box-shadow: inset 0px 1px 0px 0px #9acc85
  background: linear-gradient(to bottom, #74ad5a 5%, #68a54b 100%)
  background-color: #74ad5a
  border:1px solid  #3b6e22
  display: inline-block
  cursor: pointer
  color: #ffffff
  font-family: Arial
  font-size: 13px
  font-weight: bold
  padding: 6px 12px
button:hover
  background: linear-gradient(to bottom, #68a54b 5%, #74ad5a 100%)
  background-color: #68a54b
button:active
  position: relative
  top: 1px
</style>
